import styled from "@emotion/styled"

export const MyForYou = {
    block: styled.section`
        background-color: #FFBD2F;
        padding: 77px 0;
        width: 100%;

        img {
            border-radius: 24px;
        }

        .react-multi-carousel-list {
            overflow: visible;
        }
    `,
    wrapper: styled.div`
        max-width: 1480px;
        margin: 0 auto;
        padding: 0 20px;
    `
}